import {
    Inject,
    Injectable,
} from '@angular/core';

import { BrowserTypes } from './browser.enum';

@Injectable()
export class CheckBrowserService {

    constructor(@Inject(Window) private windowRef: Window) { }

    public checkBrowserIs(type: BrowserTypes): boolean {
        const agent: any = this.windowRef.navigator.userAgent;

        switch (type) {
            case BrowserTypes.IE:
                {
                    if (agent.indexOf('MSIE') !== -1) return true;
                    /**IE 11 */
                    if (agent.indexOf('Trident/') !== -1) return true;

                    return false;
                }
            case BrowserTypes.Chrome:
                throw new Error('Method not implemented.');
            case BrowserTypes.Firefox:
                throw new Error('Method not implemented.');
            case BrowserTypes.Edge:
                throw new Error('Method not implemented.');
            case BrowserTypes.Safari:
                throw new Error('Method not implemented.');
            default:
                return false;
        }
    }
}
